<template>
  <header class="ftn-header">
    <div class="ftn-container">
      <router-link
        :to="{ name: 'Homepage' }"
        title="Homepage"
        aria-label="Homepage"
        class="ftn-logo-wrapper"
      >
        <TrybLogo/>
      </router-link>

      <label
        class="ftn-form__label"
      >
        <input
          v-model="searchQuery"
          class="ftn-form__input"
          placeholder="Search"
          type="search"
          @keydown.enter="find"
        >
      </label>

      <button
        id="menuButton"
        type="button"
        aria-label="Open menu"
        aria-haspopup="true"
        aria-controls="sideMenu"
        :aria-expanded="menuExpanded ? 'true' : 'false'"
        @click="expand"
      >
      </button>

      <HeaderMenu/>
    </div>
  </header>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import icons from '@/mixins/icons';
import HeaderMenu from '@/components/HeaderMenu.vue';
import { Role } from '@/utils/auth';
import SideMenuButton from '@/utils/sideMenuButton';
import TrybLogo from '@/assets/icons/optimized/tryb_logo.svg?inline';


export default {
  mixins: [icons],
  name: 'Header',
  components: {
    HeaderMenu,
    TrybLogo,
  },
  data() {
    return {
      sideMenuButton: null,
      sectionsMenuOpen: false,
      currentRouteName: this.$router.currentRoute.name,
      searchQuery: '',
      timeoutID: null,
    };
  },
  mounted() {
    this.sideMenuButton = new SideMenuButton('#menuButton');
  },
  methods: {
    ...mapMutations({
      expand: 'menu/expand',
    }),
    async find() {
      this.$router.push({
        name: 'MainSearch',
        query: {
          search: this.searchQuery,
        },
      })
        .then(() => {
          this.searchQuery = null;
        })
        .catch();
    },
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      role: 'auth/role',
      isAuthenticated: 'auth/isAuthenticated',
      menuExpanded: 'menu/expanded',
    }),
    isGuest() {
      return this.role === Role.GUEST;
    },
    isAdmin() {
      return this.role === Role.ADMIN;
    },
    profile() {
      return {
        name: 'Profile',
        params: {
          username: this.user.username,
        },
      };
    },
  },
};
</script>

<style
  lang="scss"
  scoped
>
@import "~@/assets/scss/mixins";

[title="Homepage"] {
  flex-shrink: 0;
  margin-right: 16px;

  @include media-lg() {
    margin-right: 32px;
  }
}

.ftn-form {
  &__input {
    @include media-sm-only() {
      padding-right: 0 !important;
    }
  }
}

.ftn-logo-wrapper {
  display: flex;
  align-items: center;
  width: 48px;
  height: 38px;

  @include media-lg() {
    width: 78px;
    height: 48px;
  }
}

#menuButton {
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin-left: 1rem;
  flex-shrink: 0;

  background-color: transparent;
  background-image: url("~@/assets/icons/optimized/menu.svg");
  background-size: 1.5rem;
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  outline: none;
  cursor: pointer;

  @include media-lg() {
    display: none;
  }
}
</style>
